@@ -0,0 +1,252 @@
<template>
  <div class="vx-card minus-top">
    <div class="Topic p-6">
      <div class="vx-row mt-2 ml-1">
        <label class="text-font"
               style="font-size: 16px;line-height: 24px">{{$t('projectAndTopic.createNewTopic') }}</label>
      </div>
      <div class = "vx-row ml-1" style = "background-color: rgba(235,235,235, 0.3);">
        <div class = "vx-col pt-3 pb-3 pr-3">
          <div class = "vx-row pl-3">
            <label class="text-font ">{{$t('projectAndTopic.nameTopic')}}</label>
            <p class="text-font " style="color: rgba(var(--vs-danger), 1)"> * </p>
          </div>
          <div class = "vx-row pl-3">
            <vs-input  class=""
                      style="width: 255pt"
                      v-model="topic.topicName"
                      v-validate="'required'"
                      name="topic"

            ></vs-input>
            <span class="text-danger text-sm ml-6">{{
                errors.first("topic")
              }}</span>
          </div>
        </div>


      </div>
      <div class = "vx-row ml-1" style = "background-color: rgba(235,235,235, 0.3);">
        <div class = "vx-col pt-3 pb-3 pr-3">
          <div class = "vx-row pl-3">
            <label class="text-font">{{$t('trial.job')}}</label>
            <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)"> * </p>
          </div>
          <div class = "vx-row pl-3">
            <div>
              <vs-input disabled class="" style="width: 255pt"
                        v-model="jobName"
                        type="text"
                        name="jobName"></vs-input>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col mt-2 w-full">
        <!-- <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0 mb-2"
                             :settings="settings" style="max-height: 32rem; "> -->
        <div class="vx-row new-keyword-area">
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row ">
              <label class=" text-font ml-4 ">{{$t('projectAndTopic.mainKey')}}</label>
              <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)"> * </p>
              <feather-icon
                icon="HelpCircleIcon"
                class="ml-2 "
                style="color: rgb(35 27 53);width: 1rem"
              >
              </feather-icon>
            </div>
            <div class="w-full min-height-text">
              <p class="mt-2" style="font-size: 11pt;color: rgb(145 158 171)">{{$t('projectAndTopic.desMainKey')}}</p>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full ">
            <div class="vx-row ">
              <label class=" text-font ml-4 ">{{$t('projectAndTopic.subKey')}}</label>
              <feather-icon
                icon="HelpCircleIcon"
                class="ml-2 "
                style="color: rgb(35 27 53);width: 1rem"
              >
              </feather-icon>
            </div>
            <div class="w-full min-height-text">
              <p class="mt-2" style="font-size: 11pt;color: rgb(145 158 171)">{{$t('projectAndTopic.desSubKey')}}</p>
            </div>
          </div>
          <div class="vx-col md:w-1/3  ">
            <div class="vx-row ">
              <label class=" text-font ml-4">{{$t('projectAndTopic.removeKey')}}</label>
              <feather-icon
                icon="HelpCircleIcon"
                class="ml-2 "
                style="color: rgb(35 27 53);width: 1rem"
              >
              </feather-icon>
            </div>
            <div class="w-full min-height-text ml-4">
              <p class="mt-2" style="font-size: 11pt;color: rgb(145 158 171);margin-left: -10px;">{{$t('projectAndTopic.desRemoveKey')}}</p>
            </div>
          </div>
        </div>
        <div class="vx-row mt-2 new-keyword-area ml-1" style = "background-color: rgba(235,235,235, 0.3);" v-for="(item,index) in keywords" :key="index">
          <div class="vx-col md:w-1/4 pt-2 pb-3 pl-3 pr-3">
            <vs-input
              allow-edit-tags
              name="keyword"
              id="keyword"
              data-vv-validate-on="input"
              v-validate="'required'"
              type="text"
              v-model="item.keyword"
              autocomplete="off"
              v-on:keydown="checkKeypress($event,index)"
              style = "background-color:white"
              class="w-full mt-2"/>
            <span class="text-danger text-sm">{{
                errors.first('keyword')
              }}</span>
          </div>
          <div class="vx-col md:w-1/4 tag-input pt-2 pb-3 pl-3 pr-3">
            <vue-tags-input
              class="w-full mt-2"
              placeholder=""
              allow-edit-tags
              v-validate="'max:50'"
              name="keywordDependent"
              id="keywordDepend"
              v-model="item.tag"
              :tags=item.action
              @tags-changed="newTags => item.action = newTags"
              @before-adding-tag="checkTag"
              @input="checkKeypressDepend($event,index)"
            />
            <span class="text-danger text-sm">{{
                errors.first($t('projectAndTopic.subKey'))
              }}</span>
          </div>
          <div class="vx-col md:w-1/4 w-full tag-input pt-2 pb-3 pl-3 pr-3">
            <div class="vx-col" v-for="(item) in tagsListAction">
              <vue-tags-input
                class="w-full mt-2"
                placeholder=""
                allow-edit-tags
                name="keywordDependent"
                v-validate="'max:255'"
                v-model="item.tag2"
                :tags=item.action
                @tags-changed="newTags => item.action = newTags"
                @before-adding-tag="checkTag"
                @input="checkKeypressDrop($event)"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/4 pt-2 pb-3 pl-3 pr-3">
              <div class = "vx-row mt-2">
                <vs-button icon-pack="feather"
                         icon="icon-plus"
                         type="border"
                         @click="addNewRecord(index)"
              >{{$t('projectAndTopic.addKeyword')}}
              </vs-button>
              <feather-icon style="margin-left: 10px; vertical-align: middle" icon="TrashIcon"
                            svgClasses="h-6 w-6 hover:text-primary cursor-pointer" title="Xóa từ khóa"
                            @click="confirmDeleteRecords(index)"/>
              </div>

          </div>
        </div>
        <!-- </VuePerfectScrollbar> -->
        <div class="vx-row mt-2 ml-1" style = "background-color: rgba(235,235,235, 0.3);">
          <div class="vx-col md:w-1/4 pt-2 pb-3 pl-3 pr-3">
            <div class = "vx-row pl-4">
              <vs-button icon-pack="feather"
                         icon="icon-plus"
                         type="border"
                         @click="addNewRecord(-1)"
              >{{$t('projectAndTopic.addKeyword')}}
              </vs-button>
              <feather-icon style="margin-left: 10px; vertical-align: middle" icon="TrashIcon"
                            svgClasses="h-6 w-6 hover:text-primary cursor-pointer" title="Xóa từ khóa"
                            @click="confirmDeleteRecords(-1)"/>

            </div>
          </div>
        </div>
        <div class="vx-row mt-4 ml-1">

        </div>
      </div>
      <div class="vx-row mt-2 ml-1 " >
        <label class=" text-font ">{{$t('projectAndTopic.source')}}</label>
        <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)"> * </p>
        <feather-icon
          icon="HelpCircleIcon"
          class="ml-2"
          style="color: rgb(35 27 53);width: 1rem"
        >
        </feather-icon>
      </div>
      <div class="vx-row ml-1 " >
        <p class="mt-2" style="font-size: 11pt;color: rgb(145 158 171)">{{$t('projectAndTopic.selectedSource')}}:</p>
      </div>
      <div class = "vx-row ml-1 mt-2" style = "background-color: rgba(235,235,235, 0.3);">
        <div class="vx-row w-full pl-3">
          <div class="vx-col flex md:w-1/3 w-full p-2" v-for="(source, indexSource) in optionSource" :key="indexSource">
            <vs-checkbox v-model="source.check" @click="getSource(source)"></vs-checkbox>
            <span class="select-source">{{source.label}}</span>
          </div>
        </div>
      </div>
      <div class="vx-row ml-1 mt-2 " >
        <label class=" text-font">{{$t('projectAndTopic.specialSource')}}</label>
        <feather-icon
          icon="HelpCircleIcon"
          class="ml-2"
          style="color: rgb(35 27 53);width: 1rem"
        >
        </feather-icon>
      </div>
      <div class="vx-row ml-1" >
        <p class="mt-2" style="font-size: 11pt;color: rgb(145 158 171)">{{$t('projectAndTopic.textSource')}}:</p>
      </div>
      <div class = "vx-row ml-1" style = "background-color: rgba(235,235,235, 0.3);">
        <div class="vx-col w-full pt-3 pb-3 pr-3">
          <div class="pl-3 md:w-1/3 vx-row" v-for="(source, indexSource) in listSources" :key="indexSource">
            <vs-input name="source" class="w-full" v-model="source.source" ></vs-input>
            <span class="text-danger text-sm">{{errors.first("source")}}</span>
          </div>
        </div>
      </div>
      <div class = "vx-row ml-1 mt-2" style = "background-color: rgba(235,235,235, 0.3);">
        <div class="vx-col pt-3 pb-3 pr-3">
          <div class = "vx-row pl-3">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              type="border"
              @click="addSource(addIndex)"
            >{{$t('projectAndTopic.addSource')}}
            </vs-button>
            <feather-icon style="margin-left: 10px; vertical-align: middle" icon="TrashIcon"
                          svgClasses="h-6 w-6 hover:text-primary cursor-pointer" title="Xóa từ khóa"
                          @click="confirmDeleteSource(addIndex)"/>
          </div>
        </div>
      </div>
      <div class="vx-row ml-1 mt-2 " >
        <label class=" text-font">{{$t('projectAndTopic.estimate')}}</label>
        <feather-icon
          icon="HelpCircleIcon"
          class="ml-2"
          style="color: rgb(35 27 53);width: 1rem"
        >
        </feather-icon>
        <div class=" ml-1" style="color:rgb(145 158 171);" >
          ~~ {{ `${dataPreview.dataLast30Days === null ? $t('managerKeyword.notEstimate') : (dataPreview.dataLast30Days + " " + $t('managerKeyword.posts'))}` }}
        </div>
      </div>
      <div class="vx-row">
        <vs-button class="ml-auto mt-2 text-size" type="border" @click="previewData">{{$t('projectAndTopic.estimate')}}
        </vs-button>
        <vs-button class="ml-4 mt-2 text-size" type="border" @click="$router.go(-1)">{{$t('projectAndTopic.cancelText')}}
        </vs-button>
        <vs-button  v-if="isEditTopic" class="ml-4 mt-2 text-size" :disabled="!validateForm" @click="saveChanges">{{$t('projectAndTopic.update')}}
        </vs-button>
        <vs-button v-else class="ml-4 mt-2 text-size" :disabled="!validateForm" @click="saveChanges">{{ isCreateTopic ? $t('projectAndTopic.saveTopic') : $t('projectAndTopic.add') }}
        </vs-button>
      </div>

    </div>
  </div>

</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import VueTagsInput from "@johmun/vue-tags-input";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  data() {
    return {
      jobName : null,
      jobList: [
        {label:'Bán lẻ & thương mại', value: 0},
        {label: 'Bảo hiểm', value: 1},
        {label: 'Bất động sản', value: 3},
        {label: 'CNTT & Viễn thông', value: 4},
        {label: 'Dịch vụ công & nhà nước', value: 5},
        {label: 'Dịch vụ vận tải', value: 6},
        {label: 'Dược và Y tế', value: 7},
        {label: 'Fintech', value: 8},
        {label: 'Giải trí', value: 9},
        {label: 'Giáo dục', value: 10},
        {label: 'Giao nhận vận tải', value: 11},
        {label: 'Khách sạn và nhà nghỉ', value: 12},
        {label: 'Làm đẹp, Mỹ phẩm & Sức khoẻ', value: 13},
        {label: 'Luật/Pháp lý', value: 14},
        {label: 'Năng lượng', value: 15},
        {label: 'Nông nghiệp', value: 16},
        {label: 'Quảng cáo/Truyền thông', value: 17},
        {label: 'Tài chính/Ngân hàng', value: 18},
        {label: 'Thực phẩm & Đồ uống', value: 19},
        {label: 'Thương mại điện tử', value: 20},
        {label: 'Tiêu dùng nhanh', value: 21},
        {label: 'Xây dựng', value: 22},
        {label: 'Khác', value: -1},
      ],

      isUpdate: false,
      addIndex:0,
      listSources: [{
        source:''
      }],
      optionGroupTopics: [],
      topicGroupId: null,
      isEditTopic: false,
      topicNameEdit : null,
      keywordEdit : null,
      dataPreview: {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: ""
      },
      topic: {
        id: null,
        topicName: null,
        excludeKeyword: null,
        articleSource: [],
        topicGroupId: null,
        topicRelationShip: null,
        favourite: null,
        priority: null,
        color: null
      },
      sources: [],
      isCreateTopic: false,
      topicGroupName: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .30,
        suppressScrollX: true
      },
      colorTopic : null,
      keywords: [{
        keyword: "",
        action: []
      }],
      tagsListAction:[{
        action:[]
      }],
      optionSource : [
        {label : this.$t('projectAndTopic.allSource'), value : null, check:false},
        {label : 'Facebook', value : [104,105], check:false},
        {label : 'Blog & Website', value : [113], check:false},
        {label : this.$t('projectAndTopic.newsPapers'), value : [101], check:false},
        {label : 'Youtube', value : [106,107], check:false},
        {label : this.$t('projectAndTopic.forum'), value : [111,112], check:false},
        {label : 'Tiktok', value : [116,117], check:false},
        {label : 'Twitter', value : [118], check:false},
        {label : 'Instagram', value : [119, 120], check:false},

      ],
      index : 0,
    }
  },
  components: {
    vSelect,
    moment,
    VueTagsInput,
    VuePerfectScrollbar
  },
  computed: {
    selectedTopicGroup: {
      get() {
        let object = this.optionGroupTopics.find(el => el.value === this.topicGroupId);
        if (!object) return null;
        return {
          label: object.label,
          value: object.value
        }
      },
      set(object) {
        this.topicGroupId = object.value
      }
    },
    validateForm() {
      return !this.errors.any();
    },
  },

  methods: {
    getSource: function(item){
      if (item.label.includes(this.$t('projectAndTopic.allSource')) && !item.check) {
        let index = 0;
        this.optionSource.forEach(el => {
          if (index > 0){
            el.check = true;
            el.value.map(value => this.sources.push(value))
          }
          index++;
        });
      }else if (item.label.includes(this.$t('projectAndTopic.allSource')) && item.check){
        let index = 0;
        this.optionSource.forEach(el => {
          if (index == 0) {
            el.check = false;
          }
          el.check = !el.check
          index++;
        })
      }
      else if (!item.check && item.value){
        item.check = false;
        item.value.map(el => this.sources.push(el));
        if (this.optionSource.filter(el => el.check).length = 4) this.optionSource[0].check = true;
      }
      else{
        item.check = true;
        if (item.value) {
          item.value.map(value => {
            let index = this.sources.indexOf(value)
            if (index > -1){
              this.sources.splice(index, 1);
            }
          })
        }
        if (this.optionSource.filter(el => el.check).length != 4) this.optionSource[0].check = false;
      }
    },
    addSource: function(index) {
      this.index++;
      const payload = {
        email: ''
      }
      this.listSources.splice(this.index, 0, payload);
    },
    activePopupOther: function(event){
      if(event.value != undefined){
        this.topicGroupId =event.value;
      }
      this.isUpdate = false;
      this.activePopupTopic = true;
      this.topic={
        topicName: null,
        excludeKeyword:[],
        articleSource:[],
        topicGroupId:null,
        topicRelationship:null
      }
      this.dataPreview = {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: this.$t('managerKeyword.notEstimate')
      }
      this.radio = null;

      if(this.keywords.length > 1){
        this.keywords.forEach(el => {
          el.keyword  = null;
          for(let i =0; i< this.keywords.length;i++){
            this.keywords.splice(i,1);
          }
        })
      }

      this.keywords.forEach(el =>{
        if(el.keyword){
          el.keyword = null;
        }
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
      this.tagsListAction.forEach(el => {
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
    },
    activePopupOther2: function(){
      this.isUpdate = false;
      this.activePopupTopic = true;
      this.topic={
        topicName: null,
        excludeKeyword:[],
        articleSource:[],
        topicGroupId:null,
        topicRelationship:null
      }
      this.dataPreview = {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: 'Chưa ước tính'
      }
      this.radio = null;
      if(this.keywords.length > 1){
        this.keywords.forEach(el => {
          el.keyword  = null;
          for(let i =0; i< this.keywords.length;i++){
            this.keywords.splice(i,1);
          }
        })
      }

      this.keywords.forEach(el =>{
        if(el.keyword){
          el.keyword = null;
        }
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
      this.tagsListAction.forEach(el => {
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
    },
    checkTag(obj) {
      this.textInput = obj;
      const text = obj.tag.text.split(',')[0];
      obj.tag.text = text;
      if (text.length > 20) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textLength'),
          icon: 'icon-alert',
          iconPack: 'feather',
          color: 'danger'
        })
      }
      obj.addTag();
    },
    async previewData(evt) {
      evt.preventDefault();
      let keyword = this.keywords.map(key =>{
        return key.keyword;
      })
      for(let i = 0;i<keyword.length;i++){
        if(!keyword[i]){
          return this.$vs.notify({
            text: this.$t('managerKeyword.textKeyword'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      }
      if(keyword){
        keyword = this.keywords.map(keyword => {
          let action = [];
          if(keyword.action) {
            action = keyword.action.map(action => {return action.text;}).filter(item => item);
          }
          return {
            keyword: keyword.keyword,
            action: action
          }
        });
      }
      let valueCheckbox = [];
      valueCheckbox.push(101, 102, 103, 104, 105, 106, 108, 109, 110, 111, 113, 116, 117, 118, 119, 120 );

      let checked = false;
      if(checked){
        return this.$vs.notify({
          text: this.$t('managerKeyword.textKeyword2'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      let condition = JSON.parse(JSON.stringify(this.topic));
      condition.articleSource = valueCheckbox;
      condition.excludeKeyword = this.tagsListAction[0].action.map(item => item.text);
      condition.keywords = keyword;
      condition.topicGroupId = this.topicGroupId;
      condition.topicRelationship = this.radio;
      condition.favourite = false;
      this.$vs.loading();

      this.$processor.post("/search/preview-data", condition).then((response) => {
        this.dataPreview = response.data;
        let data30DaysAvg = this.dataPreview.dataLast30Days / 30 / 1440;
        let data7DaysAvg = this.dataPreview.dataLast7Days / 7 / 1440;
        let data3DaysAvg = this.dataPreview.dataLast3Days / 3 / 1440;
        let dataYesterdayAvg = this.dataPreview.dataYesterday / 1 / 1440;
        let avg = 1/((data30DaysAvg + data7DaysAvg + data3DaysAvg + dataYesterdayAvg)/4);
        if (isNaN(avg)) avg = 0;
        this.dataPreview.avgTime = avg == 0 ? this.$t('managerKeyword.cannotEstimate') : avg > 720 ? this.$t('managerKeyword.cannotEstimate') : ((avg.toFixed(0) < 15 ? " < 15 " : avg.toFixed(0)) + " " + this.$t('managerKeyword.minute'))
        this.$vs.loading.close();
      }).catch(() => {
        this.$vs.loading.close();
      });
    },

    // createTopic: function (topicGroupds) {
    //   let id = this.$route.query.id
    //   let group = topicGroupds.find(el => el.id == id);
    //   this.topicGroupName = group.groupName;
    //   this.isCreateTopic = true;
    //   this.topicGroupId = group.id;
    //   this.colorTopic = group.color;
    // },
    confirmDeleteSource (index) {
      this.activePopupTopic = false;
      if (this.listSources.length == 1) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textTheme4'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.deleteSource();
    },
    deleteSource: function(){
      this.activePopupTopic = true;
      this.listSources.splice(this.addIndex - 1, 1);
      if (this.addIndex > 1) this.addIndex--;
    },
    confirmDeleteRecords(index) {
      this.activePopupTopic = false;
      if (this.keywords.length == 1) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textTheme3'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.deleteRecordPlus(index);
    },
    deleteRecordPlus(index) {
      this.activePopupTopic = true;
      this.keywords.splice(index, 1);
    },
    checkKeypress: function (event, index) {
      const value = event.keyCode;
      if (value == 188 || value == 13) {
        this.addNewRecord(index + 1);
        setTimeout(() => {
          document.getElementsByClassName("new-keyword-area")[index + 1].getElementsByTagName("input")[0].focus()
        }, 200)
      }
    },
    checkKeypressDepend: function (event, index) {
      if (event.includes(",")) {
        document.getElementsByClassName("new-keyword-area")[index].getElementsByClassName('keyword-depend')[0]
          .getElementsByTagName("input")[0].dispatchEvent(new KeyboardEvent('keydown', {'keyCode': '13'}))
      }
    },
    checkKeypressDrop: function (event) {
      if (event.includes(",")) {
        document.getElementsByClassName('drop-keyword')[0].getElementsByTagName('input')[0]
          .dispatchEvent(new KeyboardEvent('keydown', {'keyCode': '13'}))
      }
    },
    addNewRecord(index) {
      const payload = {
        keyword: '',
      }
      this.keywords.splice(index == -1 ? this.keywords.length : (index + 1), 0, payload)
    },
    filterJobName : function () {
      let id = this.$route.query.id
      let tmp = this.jobList.find(el => el.value == id)
      this.topicGroupId = tmp.value
      this.jobName = tmp.label
    },
    initScreen() {
    },
    validURL: function(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
    },
    async saveChanges(evt) {
      evt.preventDefault();
      const result = await this.$validator.validateAll();
      if (!result) return;
      let checkSource = this.optionSource.filter(el => el.check);
      let validateSource = false;
      if (checkSource.length < 1) {
        validateSource = true;
        return this.$vs.notify({
          text: this.$t('projectAndTopic.sourceInvalid'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }else validateSource = true;
      let checkListSouce = true;
      if (this.listSources[0].source.length > 0) {
        this.listSources.forEach(source => {
          let checkSource = this.validURL(source.source);
          if (!checkSource) {
            checkListSouce = false;
            return this.$vs.notify({
              text: this.$t('projectAndTopic.inputSourceInvalid') + source.source,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
      }
      if (!validateSource || !checkListSouce) return;
      const keyword = this.keywords.map(key => {
        return key.keyword;
      })
      for (let i = 0; i < keyword.length; i++) {
        if (!keyword[i]) {
          return this.$vs.notify({
            text: this.$t('projectAndTopic.textKeyword'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      }
      if (this.keywords) {
        this.keywords = this.keywords.map(keyword => {
          let action = [];
          if (keyword.action) {
            action = keyword.action.map(action => {
              return action.text;
            }).filter(item => item);
          }
          return {
            keyword: keyword.keyword,
            action: action
          }
        });
      }
      this.valueCheckbox = [];
      this.valueCheckbox.push(101, 102, 103, 104, 105, 106, 108, 109, 110, 111, 113, 116, 117, 118, 119, 120);
      let checked = false;
      if (checked) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textKeyword2'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      if (this.valueCheckbox.length == 0) {
        return this.$vs.notify({
          text: '',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      if (this.selectedCompetitor) {
        this.valueSelected = 0;
      }
      if (this.selectedPersonal) {
        this.valueSelected = 1;
      }
      if (this.selectedOther) {
        this.valueSelected = 2;
      }
      if (!this.topic.topicName) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textTheme2'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      let topicId = this.$route.query.topicId;
      if (this.isUpdate) {
        this.topic.id = topicId;
      } else {
        this.topic.id = null;
      }
      let type = this.$route.query.id;
      this.topic.topicGroupId = this.topicGroupId;
      this.topic.articleSource = this.valueCheckbox;
      this.topic.excludeKeyword = this.tagsListAction[0].action.map(item => item.text);
      this.topic.keywords = this.keywords;
      this.topic.topicRelationship = this.radio;
      this.topic.favourite = false;
      this.topic.color = this.colorTopic;
      let path = this.isUpdate ? (`/topic/update-trial`) : `/topic/creates-trial/${type}`;
      this.$vs.loading();
      this.$business.post(path, this.isUpdate ? this.topic : [this.topic]).then(() => {
        this.$router.push('/admin/manage-topic-trial').catch(() => {
        })
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: ` ${this.isUpdate ? this.$t('projectAndTopic.update') : this.$t('projectAndTopic.add')} ` + ` ${this.$t('projectAndTopic.textAdd')} ` + `${this.topic.topicName}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        this.activePopupTopic = false;
        // this.topic ={
        //   topicName: null,
        //   topicGroupId: null,
        //   excludeKeyword:null,
        //   articleSource:[]
        // }
        this.initScreen();
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    getTopic() {
      let id = this.$route.query.topicId;
      if (!id) return;
      this.$business.get(`topic/find-by-id-trial/${id}`).then((res) => {
        let result = res.data;
        this.topic.topicName = result.topicName;
        this.topicGroupId =  result.topicGroupId;
        let keywordsRes = result.keywords;
        let excludeKeyword = result.excludeKeyword;
        keywordsRes.map(keyword => {
          let action = [];
          if (keyword.action) {
            action = keyword.action.map(action => {
              return action.text;
            }).filter(item => item);
          }
          return {
            keyword: keyword.keyword,
            action: action
          }
        });
        this.responseTagsListAction = [{"action": excludeKeyword.map (item => {
            return {
              text:item,
              tiClasses:['ti-valid']
            }
          })}];
        let sources = result.articleSource.map(el => parseInt(el));
        if (sources.length >= 8) this.optionSource.forEach(el => el.check = true);
        sources.forEach(el => {
          this.optionSource.forEach(source => {
            if (source.value && source.value.includes(el)) {
              source.check = true;
            }
          })
        })
        this.responseKeyword = keywordsRes;
        this.keywords = keywordsRes;
        this.isEditTopic = true;
        this.isUpdate = true;
      })
    },
  },

  async created() {
    this.filterJobName()
    this.initScreen();
    this.getTopic();

  }
}
</script>

<style lang="scss">
.text-font {
  font-size: 12pt;
  letter-spacing: 0.2pt;
  font-weight: bold;
  color: rgb(37 39 51);
  opacity: 0.7;
}

.tag-input .ti-input {
  border-radius: 5px;
  min-height: 37.59px;
}
.min-height-text {
  min-height: 66px;
}
::placeholder {
  color:rgba(0,0,0,.4);
  font-size: 12px;
}
</style>
